<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="$resourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  <ng-container notifications />

  <ng-container actions>
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
  </ng-container>

  @let formGroup = $formGroup();
  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="false"
    [submitLoading]="$updateLoading()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      @let userView = $resource();
      @if (userView) {
        <unity-textbox-readonly-control displayName="Full Name" [value]="userView.full_name" />
        <unity-textbox-readonly-control displayName="Email" [value]="userView.user_name" />
        <unity-dropdown-agency-user-role-control
          *unityAuthorize="'Role:View'"
          [control]="formGroup.controls.role_id"
          [userId]="userView.id" />
      }
    </unity-form-layout>
  </unity-panel-manage-shared>
  @let userId = $resource()?.id;
  @if (!!userId) {
    <unity-grid-agreement-shared *unityAuthorize="'Agreement:View'" [userId]="userId" />
  }
</unity-page-container>
